import React from "react";
import { defaultFont } from "../../../assets/fonts/defaultFont";
import LiroyText from "./LiroyText";

export function Text60({ children, containerStyle, ...props }) {
    return (
        <LiroyText {...props} fontWeight={defaultFont.regular} size={60}>
            {children}
        </LiroyText>
    );
}
